<template>
    <van-popup v-model:show="show" position="bottom" :style="{
        minWidth: '100%',
        minHeight: '100%',
        background: 'transparent',
    }">
        <div class="name_pop">
            <van-row class="title">
                <van-col span="22" style="display: flex; justify-content: center; align-items: center;">
                    {{ $t('profile.brandName') }}
                </van-col>
                <van-col span="2">
                    <img src="@/assets/profile/cs_close.png" alt="" @click="close">
                </van-col>
            </van-row>

            <div class="content">
                <InputField v-model="userName" :labelText="$t('profile.enterNickName')" />


                <div class="btn_container">
                    <MainButton title="Salvar" :activeStatus="isUpdateField" @click="onUpdateNickName" />
                </div>
            </div>
        </div>
        <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    </van-popup>
</template>

<script setup lang="ts">
import { ref, defineExpose, watch, computed } from 'vue'
import InputField from './inputField.vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import { useUserStore } from '@/stores/user'
import MainButton from '../../components/common/mainButton.vue'
import { updateNickName } from '@/view/profile/supportScript'

const userStore = useUserStore()
const id = computed(() => userStore.id)
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const userName = ref('')
const isUpdateField = ref(false)

const open = (name: string) => {
    userName.value = name
    show.value = true
}

const close = () => {
    show.value = false
}

const onUpdateNickName  = () => {
   updateNickName(id.value, userName.value, show, toastContent, isSuccess, statusRef)
}

watch(() => userName.value, (newVal) => {
    if (newVal) {
        isUpdateField.value = true
    } else {
        isUpdateField.value = false
    }

})
defineExpose({
    open,
})

</script>
<style scoped>
.van-popup {
   -ms-overflow-style: none;
   scrollbar-width: none;
   overflow-y: auto;
    border-top-left-radius: 0rem !important;
    border-top-right-radius: 0rem !important;
    border: 1px solid rgba(255, 255, 255, 0.10) !important;
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.25), inset 0 1px 0 0 rgba(255, 255, 255, .25) !important;
    backdrop-filter: blur(20px) !important;
    height: 100vh;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.title {
    padding: 10px 25px;
    font-size: 14px;
    color: #ffffffa6;
    font-size: 20px;
    display: flex;
    justify-content: center;
}

.title img {
    width: 20px;
    padding-top: 10px;
}

.van-overlay {
    background-color: #00000047
}


.content {
    padding: 30px;
}

.label {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.45);
}

.btn_container {
    padding: 30px 90px;
}
</style>